function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M478.516,154.3c49.611,15.055,60.57,73.786,51.172,137.891H529.3c-0.063-8.015-2.84-15.12-4.688-21.876A605.173,605.173,0,0,0,503.516,208.2l-6.25-22.265q-0.587-5.469-1.172-10.938C493.049,166.2,483.844,161.015,478.516,154.3Zm-160.547.781,0.781,0.391c-5.137,5.651-12.372,10.557-16.016,17.578q-2.538,13.085-5.078,26.172c-6.5,20.714-15.65,40.836-22.265,62.5q-3.516,15.233-7.032,30.469c-3.439-44.05-4.719-86.374,16.8-114.454C293.777,166.484,305.572,162.775,317.969,155.078Z"
});

var SvgOmHairstyleRecedingFrontVector = function SvgOmHairstyleRecedingFrontVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "om_hairstyle_receding_front",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmHairstyleRecedingFrontVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/om_hairstyle_receding_front_vector.d4c2bf93.svg";
export { ForwardRef as ReactComponent };